exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.sticky {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background-color: #ffffff;\n  padding: 4px;\n  margin: 10px;\n  padding: 10px;\n  box-shadow: 1px 1px #e6e2e2; }\n\n.label-small {\n  font-size: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/mobile/form-production-check-sheet.scss
// module id = ../../../../../src/app/pages/mobile/form-production-check-sheet.scss
// module chunks = 39